// LE brand values
export const brand = {
  name: 'LEGO® Education',
}
